import React from 'react'
import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import Paper from '@mui/material/Paper'

import { useTransactionStore } from '../../../common'

import Header from './Header'
import SearchBox from './SearchBox'
import TagRow from './TagRow'

interface TagManagerProps {
  selectedTags: string[]
  onTagChecked: (guid: string) => void
}

const TagManager: React.FC<TagManagerProps> = ({ selectedTags, onTagChecked }) => {
  const { tags } = useTransactionStore()

  const [searchValue, setSearchValue] = React.useState('')

  const filteredTags = tags.filter((tag) =>
    tag.name.toLowerCase().includes(searchValue.toLowerCase()),
  )

  return (
    <div className="mx-txn-tag-manager">
      <SearchBox
        onSearchValueChanged={(value) => setSearchValue(value)}
        searchValue={searchValue}
      />

      <Header />

      <Paper sx={{ boxShadow: 'none' }}>
        <List>
          {filteredTags.map((tag) => (
            <React.Fragment key={tag.guid}>
              <TagRow onTagChecked={onTagChecked} selectedTags={selectedTags} tag={tag} />
              <Divider sx={{ ml: 24 }} />
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </div>
  )
}

export default observer(TagManager)
